import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/**
 * 路由配置
 * - 所有页面级路由使用懒加载
 * - 未登录时访问受保护路由自动跳转登录页
 */

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    redirect: '/task/todo'
  },
  {
    path: '/task/create',
    name: 'TaskCreate',
    component: () => import('@/views/task/Create.vue'),
    meta: { title: '任务创建' }
  },
  {
    path: '/task/todo',
    name: 'TaskTodo',
    component: () => import('@/views/task/Todo.vue'),
    meta: { title: '待办任务' }
  },
  {
    path: '/task/today/deadline',
    name: 'TaskTodayDeadline',
    component: () => import('@/views/task/TodayDeadline.vue'),
    meta: { title: '今日截止' }
  },
  {
    path: '/task/today/plan',
    name: 'TaskTodayPlan',
    component: () => import('@/views/task/TodayPlan.vue'),
    meta: { title: '今日计划' }
  },
  {
    path: '/task/archive',
    name: 'TaskArchive',
    component: () => import('@/views/task/Archive.vue'),
    meta: { title: '已完成归档' }
  },
  {
    path: '/task/statistics',
    name: 'TaskStatistics',
    component: () => import('@/views/task/Statistics.vue'),
    meta: { title: '任务统计' }
  },
  {
    path: '/task/search',
    name: 'TaskSearch',
    component: () => import('@/views/task/Search.vue'),
    meta: { title: '搜索与筛选' }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// 导航守卫：权限校验
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  if (!to.meta.public && !authStore.isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
